import { writable } from "svelte/store";


function Controller(){
    const {subscribe, set, update} = writable({
        atLeastOneSubscription: false,
        rendered_data: false,
        stripe_subs: [],
        registered_subscriptions: [],
        registered_plans: [],
        subscriptions: [],
    })



    const controller = {
        subscribe,
        update: (input, field)=>{
            if(field === "subscriptions"){ 
                console.warn("No puedes modificar este campo.")
                return; 
            }
            update((data)=>{
                data[field] = input;
                return data;
            })
        },
        setSubscriptions: (subscriptions)=>{
            update(( data )=>{
                data.subscriptions = subscriptions;
                return data;
            })
        }
    }


    return controller;
}


const UpdateSubscriptions = function(){
    
    

    function render(subs){
        let registered_plans = [];        

        subs.map(( sub )=>{
            sub.items.data.map(( plan )=>{
                let metadata = sub.metadata;
                let addons = metadata?.addons ?? "[]";
                
                addons = JSON.parse(addons);
                plan.current_period_start = sub.current_period_start;
                plan.nextInvoice = sub.nextInvoice;
                plan.current_period_end = sub.current_period_end;
                plan.discount = sub.discount;
                plan.status = sub.status;
                plan.id_sub = sub.id;
                plan.id_plan = plan.plan.id.split("stripe_plan_").join("");
                plan.is_addon = false;
                plan.cancel_at = sub.cancel_at ?? null;
                plan.canceled_at = sub.canceled_at ?? null;
                plan.cancel_at_period_end = sub.cancel_at_period_end ?? null;
                plan.registered_at_stripe = typeof sub.id === "string" ? true : false;
                if(addons !== null){
                    Object.values(addons).map(( addon, key )=>{
                        let type = Object.keys(addons)[key];
                        addon.type = type;
                        if(plan.plan.id === "stripe_plan_"+addon.addonPlan){
                            plan.is_addon = true;
                            plan.addon = addon;
                        }
                    })
                }
                
                registered_plans.push(plan)
            })
            registered_plans = registered_plans;
        })

        let registered_subscriptions = Object.values(tripod_plans.subscriptions).filter(( subscription )=>{
            if(subscription.registered_at_stripe === true){
                SubscriptionsStore.update(true, "atLeastOneSubscription");
                return subscription;
            }
        })
        SubscriptionsStore.setSubscriptions(subs);
        SubscriptionsStore.update(registered_subscriptions, "registered_subscriptions")
        SubscriptionsStore.update(registered_plans, "registered_plans");
        SubscriptionsStore.update(true, "rendered_data");
        
    }
    
    
    if(typeof user === "undefined"){
        return false;
    }

    if(typeof user?.public_key !== "undefined"){
        turpial.fetch({
            url: [`${HOST}private/api/v1/user/subscriptions/get_subscriptions_stripe?id=${user.public_key}`],
            method: "GET",
            type: "text",
            ready: function(results){
                results = JSON.parse(results[0]);
                render(results);
                console.log("Fetched Subscriptions!")
            }
        })
        
    }else{
        return false;
    }
    

}

const SubscriptionsStore = Controller();
export {SubscriptionsStore, UpdateSubscriptions}